<template>
  <div class="tenant">
    <div class="d-flex wrap gap-5">
      <div class="d-flex ml10">
        <label class="mr5">合同类型</label>
        <el-select
          class="input200"
          v-model="queryParams.contract_type"
          clearable
        >
          <el-option
            v-for="item in contractTypes"
            :key="item.value"
            :label="item.name"
            :value="item.value">
          </el-option>
        </el-select>
      </div>

      <div class="d-flex ml10">
        <label class="mr5">合同编号</label>
        <el-select
          class="input200"
          v-model="queryParams.contract_no"
          clearable
          remote
          filterable
          :remote-method="getContractNos"
          @focus="getContractNos()"
        >
          <el-option
            v-for="item in contractNos"
            :key="item.id"
            :label="item.contract_no"
            :value="item.contract_no">
          </el-option>
        </el-select>
      </div>

      <div class="d-flex ml10">
        <label class="mr5">国家</label>
        <el-select
          class="input200"
          v-model="queryParams.country"
          clearable
          @change="changeCountry"
        >
          <el-option
            v-for="item in countries"
            :key="item.code"
            :label="item.name"
            :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="d-flex">
        <label class="mr5">省/直辖市</label>
        <el-select
          class="input200"
          v-model="queryParams.province"
          clearable
          @change="
            queryParams.city = undefined;
            queryParams.id = undefined;
            getCityOpts();
            getTenantsOpts()
          "
        >
          <el-option
            v-for="item in addressOptions"
            :key="item.code"
            :label="item.name"
            :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="d-flex ml10">
        <label class="mr5">市</label>
        <el-select
          class="input200"
          clearable
          v-model="queryParams.city"
          :disabled="!queryParams.province"
          @change="queryParams.id = undefined;getTenantsOpts()"
        >
          <el-option
            v-for="item in cityOpts"
            :key="item.code"
            :label="item.name"
            :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="d-flex ml10">
        <label class="mr5">状态</label>
        <el-select
          class="input200"
          v-model="queryParams.status"
          clearable
        >
          <el-option
            v-for="item in statusOpts"
            :key="item.value"
            :label="item.name"
            :value="item.value">
          </el-option>
        </el-select>
      </div>

      <div class="d-flex ml10">
        <label>租户名称</label>
        <!-- <el-cascader
            :before-filter="remoteSearch"
            filterable
            :options="address"
            :show-all-levels="false"
            clearable
            v-model="queryParams.id"
            :props="{
              label: 'name',
              value: 'code',
              emitPath:false
            }"
            popper-class="cascader-style"
            @expand-change="expandChange"
            >
          </el-cascader> -->
        <el-select
          class="input200"
          v-model="queryParams.id"
          remote
          filterable
          clearable
          :remote-method="getTenantsOpts"
          @focus="getTenantsOpts()"
          @change="$forceUpdate();"
        >
          <el-option
            v-for="item in tenantOpts"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </div>

      <div class="d-flex ml20">
        <!-- 结束日期： -->
        <label class="mr5">结束日期</label>
        <el-date-picker
          v-model="queryParams.end_date"
          type="date"
          :placeholder="`请选择`">
        </el-date-picker>
      </div>

      <!-- 经销商名称 -->
      <div class="d-flex ml10">
        <label>经销商名称</label>
        <el-select
          class="input200"
          v-model="queryParams.dealer_id"
          :remote-method="getDealerSelect"
          @focus="getDealerSelect()"
          remote
          :disabled="user.role_id !== 1"
          filterable
          clearable
        >
          <el-option
            v-for="item in dealerOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>

      <el-button
        class="ml10"
        type="primary"
        size="small"
        @click="search"
      >查询</el-button>

      <el-button
        class="ml10"
        type="primary"
        size="small"
        @click="openCreate"
      >新增</el-button>

      <el-button
        class="ml10"
        type="primary"
        size="small"
        @click="importList"
      >导入</el-button>
    </div>

    <div class="page-card">
      <el-table
        class="mt10"
        border
        @sort-change="sortChange"
        :data="list">
        <el-table-column type="index" label="#"></el-table-column>
        <el-table-column
          v-for="(item) in headers"
          :key="item.id"
          :type="item.type"
          :label="item.label"
          :prop="item.prop"
          :width="item.width"
          :sortable="!!item.sortKey ? 'custom': false"
          :sort-by="item.sortKey">
          <template slot-scope="scope">
            <template v-if="item.prop === 'handle'">
              <el-button
                type="text"
                @click="openEdit(scope.row)"
              >
                编辑
              </el-button>

              <el-button
                type="text"
                @click="openView(scope.row)"
              >
                详情
              </el-button>
            </template>
            <span v-else-if="item.prop === 'remark'" :title="scope.row[item.prop]">
              {{ scope.row[item.prop] | pre10 }}
            </span>
            <span v-else>{{ scope.row[item.prop] }}</span>
          </template>
        </el-table-column>
      </el-table>
      
      <pagination :queryParams="queryParams" :getList="getList" />
    </div>

    <edit
      ref="Edit"
      @fresh="getList"
    />
    <ImportFile :link="'/template/basic/tenant/租户管理.xlsx'" ref="importFile" @complete="getImport" />
  </div>
</template>

<script>
import {
  mapGetters
} from 'vuex';
import store from '@/store';
import ImportFile from '@/components/common/ImportFile.vue';
import Pagination from '@/components/common/Pagination';
import Edit from './components/edit.vue';
import {
  tenantManage,
  getTenantOpts,
  tenantImport,
  dealerSelect,
  tenantContractNos
} from '@/api.js';
import {
    getAddressData
} from '@/requests/system'
import {
  pageSize
} from '@/utils/Config.js';
export default {
  name: 'TenantManagement',
  components: {
    Pagination,
    Edit,
    ImportFile
  },
  computed: {
    ...mapGetters(['user', 'countries']),
    // cityOpts() {
    //   const {
    //     province
    //   } = this.queryParams

    //   const p = this.addressOptions.find(i => i.code === province)
    //   if (!p) {
    //     return []
    //   } else {
    //     return p.children || []
    //   }
    // },
    // address(){
    //   // 区县下一级列表初始化
    //   let arr = this.$utils.deepCopy(this.addressOptions)
    //               // 避免重复做处理
    //               for (const item of arr) {
    //     item.code = item.code + 'code'
    //   }
    //   for (const province of arr) {
    //     for (const city of province.children) {
    //       for (const county of city.children) {
    //         this.$set(county,'children',[])
    //       }
    //     }
    //   }
    //   this.tenantOpts.forEach(item => {
    //     const province = arr.find(i => i.code === item.province + 'code')
    //     if (province) {
    //       const city = province.children.find(i => i.code === item.city)
    //       if (city) {
    //         const county = city.children.find(i => i.code === item.area)
    //         if (county) {
    //           county.children.push({
    //             name: item.name,
    //             code: item.id
    //           })
    //         }
    //       }
    //     }
    //   })
    //   return arr
    // }
  },
  filters: {
    pre10(value) {
      if (typeof value !== 'string') {
        return value;
      }

      return value.length > 10 ? `${value.substring(0, 10)}...` : value
    }
  },
  data(){
    return {
      queryParams: {
        pageIndex: 1,
        pageSize,
        _total: 0
      },
      statusOpts: [
        {
          name: `正常`,
          value: 1
        },
        {
          name: `冻结`,
          value: 2
        }
      ],
      contractTypes: [
        {
          name: `正式`,
          value: 1
        },
        {
          name: `试用`,
          value: 0
        } 
      ],
      contractNos: [],
      tenantOpts: [],
      headers: [],
      list: [],
      dealerOptions: [], //经销商下拉列表
      addressOptions: [],
      cityOpts: []
    }
  },
  methods: {
    getList() {
      const {
        pageIndex,
        pageSize,
        order,
        orderBy,
        id,
        province,
        city,
        status,
        end_date,
        dealer_id,
        contract_type,
        contract_no,
        country
      } = this.queryParams
      const query = {
        per_page: pageSize,
        page: pageIndex,
        order,
        order_column: orderBy,
        id,
        province,
        city,
        status,
        end_date,
        dealer_id,
        contract_type: contract_type === '' ? undefined : contract_type,
        contract_no,
        country
      }

      this.$request('get', tenantManage, query)
      .then(res => {
        if (res) {
          const {
            columns,
            data,
            total
          } = res

          this.list = data
          this.headers = this.$utils.generateColumns(columns)
          this.queryParams._total = total
        }
      })
    },
    getContractNos(contract_no = undefined) {
      // 获取合同编号
      const { country } = this.queryParams
      const query = {
        contract_no,
        country
      }

      return this.$request('get', tenantContractNos, query)
      .then(res => {
        this.contractNos = res || []
      })
    }, 
    getAddress(code) {
      if (!code) return

      getAddressData(code)
      .then(res => {
        const addressOptions = res || []

        this.addressOptions = addressOptions
      })
    },
    getCityOpts() {
      const {
        province
      } = this.queryParams

      const p = this.addressOptions.find(i => i.code === province)
      if (!p) {
        this.cityOpts = []
      } else {
        this.cityOpts = p.children || []
      }
    },
    resetAddressParams() {
      this.queryParams.province = undefined
      this.queryParams.city = undefined
      this.queryParams.id = undefined
    },
    changeCountry(value) {
      this.resetAddressParams()
      this.addressOptions = []
      this.getAddress(value)
    },
    getTenantsOpts(name = null) {
      return this.$request('get', getTenantOpts, { name,province:this.queryParams.province,city:this.queryParams.city })
      .then(res => {
        this.tenantOpts = res || []
        this.$forceUpdate();
      })
    },
    sortChange(item) {
      // 排序方法
      const { column, order } = item
      const orderString = order ? order === 'ascending' ? 'asc' : 'desc' : undefined
      const orderBy = order ? column.sortBy : undefined

      this.queryParams.order = orderString
      this.queryParams.orderBy = orderBy
      this.getList()
    },
    search() {
      this.queryParams.pageIndex = 1
      this.getList()
    },
    openCreate() {
      // 新增
      const {
        Edit
      } = this.$refs

      Edit && Edit.open()
    },
    openEdit(detail) {
      // 编辑
      const {
        Edit
      } = this.$refs

      Edit && Edit.open({ detail })
    },
    openView(detail) {
      // 查看详情
      const {
        Edit
      } = this.$refs

      Edit && Edit.open({ detail, isView: true })
    },
    // 开始导入
    importList() {
      this.$refs.importFile.show();
    },
    // 接收导入文件信息
    getImport(file) {
      const info = {
        file_id: file.fileId,
      };
      this.$request('post', tenantImport, info).then((res) => {
        if (res) {
          // 导入成功
          this.$message.success(`导入成功`);
          this.search();
        }
      });
    },
    async remoteSearch(value){
      let res = await this.$request('get', getTenantOpts, { name:value })
      this.tenantOpts = res || []
    },
    expandChange(node){
      if (node[2]) {
        // this.getTenantsOpts(null,node[2])
      }
    },
    getDealerSelect(name = ''){
      this.$request('get', dealerSelect, { country: this.user.country, name,struct: 1 })
      .then((res) => {
        this.dealerOptions = res
      })
    },
    initDealerOpts(){
      // 初始化经销商查询条件
      return new Promise((resolve) => {
        if (this.user.role_id === 6) {
          this.getDealerSelect()
          this.$set(this.queryParams, 'dealer_id', this.user.dealer_id)

          this.$nextTick(() => {
            resolve()
          })
        } else {
          resolve()
        }
      })
    }
  },
  async created() {
    store.dispatch('setCountries')
    await this.initDealerOpts()

    this.getList()
  }
}
</script>

<style>
.tenant{
  /* background: red; */
  min-width: 1600px;
  /* width: 1600px; */
}
</style>